// Parcours réel de Kévin. Ne rien inventer ici.

export const formations = [
  {
    id: 'f1',
    label: 'Formation',
    title: 'MBA Management de projet — spécialité Expert UX/UI',
    place: 'MyDigitalSchool, Angers',
    years: '2024 – 2026',
    description:
      "Formation de niveau Bac+5 orientée gestion de projet digital et design d'expérience utilisateur. Spécialisation en conception d'interfaces, design system et pilotage de projets UX/UI."
  },
  {
    id: 'f2',
    label: 'Formation',
    title: 'Bachelor Chef de projet e-business — option Webdesign',
    place: 'La Digital School / Open Campus, Trélazé',
    years: '2023 – 2024',
    description:
      "Formation orientée stratégie digitale et conception web. Apprentissage de la direction artistique, du webdesign et de la gestion de projets e-commerce."
  },
  {
    id: 'f3',
    label: 'Formation',
    title: 'Bachelor Cycle Web & Multimédia',
    place: 'MyDigitalSchool, Angers',
    years: '2022 – 2023',
    description:
      'Formation pluridisciplinaire couvrant le développement web, le design graphique et la production multimédia.'
  },
  {
    id: 'f4',
    label: 'Formation',
    title: 'BTS SIO option SLAM',
    place: 'Lycée Chevrollier, Angers',
    years: '2018 – 2020',
    description:
      'Formation technique en développement logiciel et applications. Acquisition des bases en programmation (HTML, CSS, JavaScript, PHP, SQL) et gestion de bases de données.'
  },
  {
    id: 'f5',
    label: 'Formation',
    title: 'Bac S option ISN',
    place: 'Lycée',
    years: '2017',
    description: 'Spécialité Informatique et Sciences du Numérique.'
  }
];

export const experiences = [
  {
    id: 'e1',
    label: 'Expérience',
    title: 'UX/UI Designer & Intégrateur',
    place: 'Agence iStudio, Cholet',
    years: '2025 – 2026',
    duration: '6 mois en alternance',
    description:
      "Conception d'interfaces et intégration web en contexte agence. Création de maquettes sur Figma, intégration front-end et participation aux projets clients en cycle complet."
  },
  {
    id: 'e2',
    label: 'Expérience',
    title: 'UX/UI Designer',
    place: 'Groupe ERAM / Gémo, St Pierre Montlimart',
    years: '2025',
    duration: '6 mois',
    description:
      "Refonte et animation du site Gémo. Conception des maquettes sur Figma et intégration front-end des pages produits pour l'une des principales enseignes de chaussures françaises."
  },
  {
    id: 'e3',
    label: 'Expérience',
    title: 'UX/UI Designer',
    place: 'Prospect-it, Angers',
    years: '2024',
    duration: '3 semaines',
    description:
      'Conception de maquettes UX/UI pour des interfaces client. Travail sur les wireframes, les parcours utilisateurs et la mise en page responsive.'
  },
  {
    id: 'e4',
    label: 'Expérience',
    title: 'Développeur web WordPress',
    place: 'Mimosa Communication, Angers',
    years: '2024',
    duration: '2 mois',
    description:
      'Création de sites web à partir de maquettes graphiques. Intégration de contenus, configuration de thèmes et développement de pages sous WordPress/Elementor.'
  },
  {
    id: 'e5',
    label: 'Expérience',
    title: 'Intégrateur front-end',
    place: 'IP Focus Réseaux, Angers',
    years: '2024',
    duration: '2 mois',
    description:
      "Refonte complète du site web de l'entreprise. Intégration de contenus, création de posts LinkedIn et préparation d'une campagne emailing."
  },
  {
    id: 'e6',
    label: 'Expérience',
    title: 'Stagiaire web',
    place: "Kara Technology, St Barthélemy d'Anjou",
    years: '2023',
    duration: '2 mois',
    description:
      'Refonte de deux sites web clients. Intégration sous WordPress, mise en page responsive et optimisation des contenus existants.'
  },
  {
    id: 'e7',
    label: 'Expérience',
    title: 'Stagiaire web',
    place: 'Sublim&Home, Pellouailles-les-Vignes',
    years: '2022',
    duration: '3 semaines',
    description:
      "Refonte du site vitrine de l'entreprise et création de la page LinkedIn. Mise en place de la présence digitale de l'entreprise."
  },
  {
    id: 'e8',
    label: 'Expérience',
    title: 'Intégrateur front-end freelance',
    place: 'Indépendant',
    years: '2022 – Présent',
    duration: '',
    description:
      "Intégration WordPress/Elementor pour des PME et associations. Réalisations : refonte du site de l'UFAB49 (club de basket, Angers) et de l'ASGAP."
  }
];
